async function fetchWithAuth(url, params = {}, req) {
	const headers = req?.headers ?? {};
	const frontendUrl = process?.env?.FRONTEND_URL;
	const host = frontendUrl?.replace('https://', '')?.replace('http://', '');

	const { throwOnHttpErrorStatus, ...restParams } = params;

	const _params = {
		...restParams,
		headers: {
			'Content-Type': 'application/json',
			...headers,
			...(typeof window === 'undefined' && host ? { host } : {}),
		},
	};

	return fetch(url, _params).then((r) => {
		if (throwOnHttpErrorStatus && !r.ok) {
			return r.json().then((err) => Promise.reject(err));
		}

		return r.json();
	});
}

export default fetchWithAuth;
